export default function WIP(props) {
  return (
    <section className="m-4 text-center">
      <h1>WIP</h1>
      <p>Be back when we're ready.</p>
    </section>
  )
}
